// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"4123574321e2c170","6831":"62c3a8c5327e070f","8503":"9353e4cc383dbda2","9683":"9ed7cb3e3151ec08"}[chunkId] + ".js";
};